import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const scrollTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  document.querySelector("main")?.scrollTo?.(0, 0);
  document.body.style.overflow = "";
  document.documentElement.style.overflow = "";
};

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    scrollTop();
  }, [pathname]);
  return null;
}
